import React, {
  createContext,
  type PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import { ThemeProvider } from "@mui/material/styles";
import {
  DarkThemeWithResponsiveFontSizes as DarkTheme,
} from "../theme";

type ColorModeContextType = {
  mode: string;
  setMode: () => void;
};

export const ColorModeContext = createContext<ColorModeContextType>(
  {} as ColorModeContextType,
);

export const ColorModeContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  // Always use dark mode - ignore localStorage and system preference
  const [mode, setMode] = useState("dark");

  useEffect(() => {
    // Always set dark mode in localStorage
    window.localStorage.setItem("colorMode", "dark");
  }, [mode]);

  const setColorMode = () => {
    // Do nothing - theme toggle is disabled
    // This function is kept for compatibility but doesn't change the mode
  };

  return (
    <ColorModeContext.Provider
      value={{
        setMode: setColorMode,
        mode,
      }}
    >
      <ThemeProvider theme={DarkTheme}>
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export const useColorModeContext = () =>
  useContext(ColorModeContext);
